export default function findByProperty<T extends Record<string, any>>(
  array: T[],
  property: keyof T,
  value: string,
): T {
  if (!array || !property || !value) return null
  return array?.find((entry) => entry?.[property] === value) ?? null
}
